'use strict';

import moment from "moment";

export class DatePicker {
	constructor(changeDayCallback = _ => { }) {
		this.dateFormat = "dddd, MMMM Do YYYY";
		this.changeDayCallback = changeDayCallback;

		this.datePickerContainer = document.getElementById('appointmentDatePicker');
		this.appointmentDate = this.datePickerContainer.querySelector("#appointmentDate");
		this.currentDate = moment(this.appointmentDate.innerHTML, this.dateFormat);
		this.prevDateButton = this.datePickerContainer.querySelector("#prevDate");

		this.setupAppointmentDate();
	}

	setupAppointmentDate() {	
		this.prevDateButton.addEventListener("click", this.prevDateButtonListener.bind(this));
		
		const nextDateButton = this.datePickerContainer.querySelector("#nextDate");
		nextDateButton.addEventListener("click", this.nextDateButtonListener.bind(this));

		// create a new instance of 'MutationObserver' named 'observer', 
		// passing it a callback function
		const observer = new MutationObserver(_ => {
			this.currentDate = moment(this.appointmentDate.innerHTML, this.dateFormat);
			if (this.currentDate.isSameOrBefore(moment(this.appointmentDate.dataset.date))) {
				this.prevDateButton.disabled = true;
			} else {
				this.prevDateButton.disabled = false;
			}
		});

		// call 'observe' on that MutationObserver instance, 
		// passing it the element to observe, and the options object
		observer.observe(this.appointmentDate, {characterData: false, childList: true, attributes: false});
	}

	prevDateButtonListener(e) {
		if (e) {
			e.preventDefault();
		}
		this.currentDate = this.currentDate.subtract(1, "day");
		this.appointmentDate.innerHTML = this.currentDate.format(this.dateFormat);
		this.throttleUpdateProviderList();
		if (this.currentDate.isSameOrBefore(moment(this.appointmentDate.dataset.date))) {
			this.prevDateButton.disabled = true;
		}
	}

	nextDateButtonListener(e) {
		if (e) {
			e.preventDefault();
		}
		this.currentDate = this.currentDate.add(1, "day");
		this.prevDateButton.disabled = false;
		this.appointmentDate.innerHTML = this.currentDate.format(this.dateFormat);
		this.throttleUpdateProviderList();
	}

	throttleUpdateProviderList() {
		clearTimeout(this._timeout);
		this._timeout = setTimeout(async () => {
			this.changeDayCallback(this.currentDate);
		}, 500);
	}

	setCurrentDate(date) {
		this.currentDate = moment(date);
		this.appointmentDate.dataset.date = date;
		this.appointmentDate.innerHTML = this.currentDate.format(this.dateFormat);
	}
}